/** Lab routes and picker tab. Off in production Cloud Run builds. */
export function isLabEnabled() {
  return (
    process.env.REACT_APP_DEV_AUTH === '1' ||
    process.env.REACT_APP_LAB === '1'
  );
}
